<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-shield-account</v-icon> <span>Edição de Feature</span>
        </h1>
  
        <div class="mt-16">
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
          <feature v-else method="update" :feature="feature"></feature>
        </div>
    </section>
  </template>
  <script>
  import Feature from '@/components/features/Feature'
  import FeatureAPI from "@/api/Feature.js";
  
  export default {
    components: {
      Feature
    },
    beforeCreate(){
      document.title = "Hefesto - Edição de Features";
    },
    data: () => ({
        feature: {},
        loading:true
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "features.write"])) {
        this.$router.push('/admin');
      }
  
      FeatureAPI.find(this.$route.params.id).then(({data}) => { this.feature = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Gestão Features',
            disabled: false,
            to: '/internal_management/features',
            exact: true,
          },
          {
            text: 'Registo de Feature',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  